"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[2454],{

/***/ 96363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   OY: () => (/* binding */ StyledCardTitle),
/* harmony export */   Zb: () => (/* binding */ Card),
/* harmony export */   di: () => (/* binding */ StyledCardTitleContainer),
/* harmony export */   uO: () => (/* binding */ CardSection)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10334);
/* harmony import */ var lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48908);
/* harmony import */ var lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45199);
/* harmony import */ var _utils_overrides__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2009);
/* harmony import */ var _Column__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63034);







const StyledCardRoot = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme, $active, $focused, $spaced, $nested, $flat })=>{
    return {
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandPadding */ .ft)(lodash_defaultTo__WEBPACK_IMPORTED_MODULE_0___default()($spaced, true) ? $theme.sizing.scale600 : "0px"),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderRadii */ .uJ)($theme.borders.surfaceBorderRadius),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBaseWebBorder */ .yc)({
            borderWidth: $theme.borders.border100.borderWidth,
            borderColor: $active && $focused ? $theme.colors.borderSelected : $theme.colors.borderOpaque,
            borderStyle: "solid"
        }),
        backgroundColor: $theme.colors.background,
        outlineWidth: $focused ? "2px" : $active ? "1px" : "0px",
        outlineStyle: "solid",
        outlineColor: $theme.colors.borderSelected,
        boxShadow: $nested ? "0px -1px 0px 0px rgba(0, 0, 0, 0.24) inset, 0px 1px 1px 0px rgba(0, 0, 0, 0.16)" : $flat ? undefined : $theme.lighting.depth2,
        ...$theme.typography.LabelSmall
    };
});
const StyledCardRootSecondary = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .withStyle */ .w1)(StyledCardRoot, (props)=>{
    return {
        backgroundColor: "transparent",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderColors */ .gC)(props.$active ? props.$theme.colors.alpha500 : props.$theme.colors.alpha300),
        boxShadow: props.$active ? props.$theme.lighting.shadowButtonInset : "none",
        outlineWidth: props.$focused ? "2px" : "0px",
        outlineOffset: props.$focused ? "1px" : "0px",
        paddingBottom: props.$theme.sizing.scale500
    };
});
const StyledCardTitleContainer = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: $theme.sizing.scale400,
        justifyContent: "space-between"
    };
});
const StyledCardTitle = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        ...$theme.typography.subHeading,
        marginBottom: $theme.sizing.scale400
    };
});
const StyledCardSubtitle = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .styled */ .zo)("div", ({ $theme })=>{
    return {
        ...$theme.typography.LabelMedium,
        marginBottom: $theme.sizing.scale400
    };
});
/** A rectangular box around some content */ const Card = (props)=>{
    const { Root, Title, TitleContainer, Subtitle } = (0,_utils_overrides__WEBPACK_IMPORTED_MODULE_5__/* .useOverrides */ .QG)({
        Root: props.variant == "secondary" ? StyledCardRootSecondary : StyledCardRoot,
        TitleContainer: StyledCardTitleContainer,
        Title: StyledCardTitle,
        Subtitle: StyledCardSubtitle
    }, props.overrides);
    // add padding to this card by default, but don't if explicitly told not to, or if the card contains card sections, which add their own padding
    const spaced = props.$spaced ?? !react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(props.children).every((child)=>{
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child) && child.type.displayName === "CardSection";
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Root, {
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
            "title"
        ]),
        $spaced: spaced
    }, (props.title || props.titleAction) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(TitleContainer, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Title, null, props.title), props.subtitle && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Subtitle, null, props.subtitle)), props.titleAction), props.children);
};
const CardSection = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)();
    const padding = props.$padding == "xsmall" ? $theme.sizing.scale300 : props.$padding == "small" ? $theme.sizing.scale500 : $theme.sizing.scale600;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Column__WEBPACK_IMPORTED_MODULE_6__/* .Column */ .s, {
        dataTestId: props.dataTestId,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onClick: props.onClick,
        $as: props.$as ?? "section",
        $gap: $theme.sizing.scale500,
        $style: {
            backgroundColor: props.variant === "secondary" ? $theme.colors.backgroundSecondary : "transparent",
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .paddingUtil */ .N1)(padding),
            ...props.$ruled ? (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .expandBorderBottom */ .lK)({
                borderWidth: $theme.borders.border100.borderWidth,
                borderColor: $theme.colors.borderOpaque,
                borderStyle: "solid"
            }) : undefined,
            ":last-child": {
                borderBottomWidth: 0,
                borderBottomLeftRadius: $theme.borders.surfaceBorderRadius,
                borderBottomRightRadius: $theme.borders.surfaceBorderRadius
            },
            ":first-child": {
                borderTop: undefined,
                borderTopLeftRadius: $theme.borders.surfaceBorderRadius,
                borderTopRightRadius: $theme.borders.surfaceBorderRadius
            },
            ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props.$style, "appearance") ?? {}
        }
    }, props.children);
};
CardSection.displayName = "CardSection";


/***/ }),

/***/ 63034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap,
        "data-testid": props.dataTestId
    }));


/***/ }),

/***/ 87650:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  rJ: () => (/* binding */ BetaPill),
  Tq: () => (/* binding */ FailurePill),
  FK: () => (/* binding */ PendingPill),
  DR: () => (/* binding */ Pill),
  lA: () => (/* binding */ RetryingPill),
  PS: () => (/* binding */ RunningPill),
  sP: () => (/* binding */ ScheduledPill),
  Wg: () => (/* binding */ SuccessPill)
});

// UNUSED EXPORTS: InfoPill, NewPill, PillContainer

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
var isObject = __webpack_require__(93702);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(73352);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(69525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/ErrorInfoIcon.tsx




const ErrorInfoIcon = (props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        viewBox: "0 0 20 20",
        ...omit_default()(props, "color")
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M9.99992 2C9.44554 2 8.97063 2.33782 8.76945 2.81901L1.53377 15.2982V15.2995C1.40319 15.5098 1.33375 15.7524 1.33325 16C1.33325 16.3536 1.47373 16.6928 1.72378 16.9428C1.97382 17.1929 2.31296 17.3333 2.66659 17.3333C2.69787 17.3331 2.72914 17.3318 2.76034 17.3294L2.76294 17.3333H9.99992H17.2369L17.2395 17.3281C17.2707 17.331 17.3019 17.3327 17.3333 17.3333C17.6869 17.3333 18.026 17.1929 18.2761 16.9428C18.5261 16.6928 18.6666 16.3536 18.6666 16C18.6663 15.752 18.5969 15.5089 18.4661 15.2982L18.4556 15.2799C18.4552 15.2795 18.4548 15.2791 18.4543 15.2786L11.2304 2.81901C11.0292 2.33782 10.5543 2 9.99992 2ZM9.19132 7.57292H10.8085L10.6744 11.888H9.32544L9.19132 7.57292ZM10.0025 13.207C10.5505 13.207 10.8788 13.5019 10.8788 14.0052C10.8788 14.4992 10.5505 14.793 10.0025 14.793C9.45052 14.793 9.11971 14.4992 9.11971 14.0052C9.11971 13.5019 9.44986 13.207 10.0025 13.207Z",
        fill: props.color ? props.color : $theme.colors.red500
    }));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/FailureCircleIcon.tsx
var FailureCircleIcon = __webpack_require__(46666);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/KebabMenuIcon.tsx
var KebabMenuIcon = __webpack_require__(56029);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/SuccessCircleIcon.tsx
var SuccessCircleIcon = __webpack_require__(17447);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(45199);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/PlainButton.tsx
var PlainButton = __webpack_require__(77301);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ActionIcon.tsx
var ActionIcon = __webpack_require__(91797);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ScheduleIcon.tsx
var ScheduleIcon = __webpack_require__(75574);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/components/Pill.tsx














const getPillColors = (theme, error, color)=>{
    let backgroundColor;
    let textColor;
    let hoverColor;
    if (error) {
        backgroundColor = theme.colors.red50;
        textColor = theme.colors.red500;
        hoverColor = theme.colors.red600;
    } else if (isObject_default()(color)) {
        backgroundColor = color.backgroundColor;
        textColor = color.color;
        hoverColor = color.color;
    } else {
        switch(color){
            case "purple":
                {
                    backgroundColor = theme.colors.purple100;
                    textColor = theme.colors.purple400;
                    hoverColor = theme.colors.purple500;
                    break;
                }
            case "yellow":
                {
                    backgroundColor = theme.colors.yellow50;
                    textColor = theme.colors.yellow600;
                    hoverColor = theme.colors.yellow700;
                    break;
                }
            case "green":
                {
                    backgroundColor = theme.colors.green100;
                    textColor = theme.colors.green600;
                    hoverColor = theme.colors.green700;
                    break;
                }
            case "red":
                {
                    backgroundColor = theme.colors.red100;
                    textColor = theme.colors.red600;
                    hoverColor = theme.colors.red700;
                    break;
                }
            case "blue":
                {
                    backgroundColor = theme.colors.cyan50;
                    textColor = theme.colors.cyan700;
                    hoverColor = theme.colors.primary700;
                    break;
                }
            case "teal":
                {
                    backgroundColor = "#A2B9D736";
                    textColor = "#404B5A";
                    hoverColor = "#A2B9D736";
                    break;
                }
            case "light":
                {
                    backgroundColor = theme.colors.alpha100;
                    textColor = theme.colors.alpha500;
                    hoverColor = theme.colors.alpha600;
                    break;
                }
            case "alpha200":
                {
                    backgroundColor = theme.colors.alpha200;
                    textColor = theme.colors.neutralMax;
                    hoverColor = theme.colors.alpha700;
                    break;
                }
            case "production":
                {
                    backgroundColor = theme.colors.backgroundProduction;
                    textColor = "#5634AE";
                    break;
                }
            case "success":
                {
                    backgroundColor = theme.colors.green50;
                    textColor = theme.colors.green700;
                    break;
                }
            case "error":
                {
                    backgroundColor = theme.colors.red50;
                    textColor = theme.colors.red700;
                    break;
                }
            default:
            case "alpha":
                {
                    backgroundColor = theme.colors.alpha100;
                    textColor = theme.colors.alpha600;
                    hoverColor = theme.colors.alpha700;
                    break;
                }
        }
    }
    return {
        backgroundColor,
        color: textColor,
        hoverColor
    };
};
const PillContainer = (0,styled/* styled */.zo)("span", ({ $theme, $color, $error, $style })=>{
    const { backgroundColor, color } = getPillColors($theme, $error, $color);
    return {
        ...(0,utils/* paddingHorizontal */.WB)($theme.sizing.scale100),
        ...(0,utils/* paddingVertical */.i6)(0),
        display: "inline-flex",
        alignItems: "center",
        ...(0,utils/* expandBorderRadii */.uJ)("4px"),
        whiteSpace: "nowrap",
        ...$theme.typography.MonoLabelSmall,
        height: $theme.sizing.scale700,
        backgroundColor,
        color,
        ...$style
    };
});
/** A small colored span serving as a discrete label */ const Pill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    const { hoverColor } = getPillColors($theme, props.error, props.$color);
    return /*#__PURE__*/ react.createElement(PillContainer, {
        ...omit_default()(props, [
            "error",
            "dismissable",
            "onDismiss"
        ]),
        $error: props.error
    }, props.children, props.dismissable && /*#__PURE__*/ react.createElement(PlainButton/* PlainButton */.D, {
        onClick: props.onDismiss,
        $style: {
            display: "inline-flex",
            marginLeft: $theme.sizing.scale100,
            ":hover": {
                color: hoverColor,
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ react.createElement(CloseIcon/* CloseIcon */.T, null)));
};
/** A pill for consistency in how we tag things that are in beta */ const BetaPill = (props)=>{
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "purple"
    }, props.children ?? "beta");
};
/** A pill for consistency in how we tag things that are newly released */ const NewPill = (props)=>{
    return /*#__PURE__*/ React.createElement(Pill, {
        $style: props.$style,
        $color: "green"
    }, props.children ?? "new");
};
/** A pill showing info */ const InfoPill = (props)=>{
    const [_css, $theme] = useStyletron();
    return /*#__PURE__*/ React.createElement(Pill, {
        $style: props.$style,
        $color: "blue"
    }, /*#__PURE__*/ React.createElement(InfoIcon, {
        $color: $theme.colors.blue600,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const SuccessPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "success"
    }, /*#__PURE__*/ react.createElement(SuccessCircleIcon/* SuccessCircleIcon */.B, {
        color: $theme.colors.green500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const FailurePill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "error"
    }, /*#__PURE__*/ react.createElement(FailureCircleIcon/* FailureCircleIcon */.n, {
        color: $theme.colors.negative500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const RunningPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: props.$style,
        $color: "blue"
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            marginRight: $theme.sizing.scale200,
            marginTop: $theme.sizing.scale100
        }
    }, /*#__PURE__*/ react.createElement(ActionIcon/* ActionIcon */.A, null)), props.children);
};
const PendingPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            color: $theme.colors.black,
            ...props.$style
        },
        $color: "alpha"
    }, /*#__PURE__*/ react.createElement(KebabMenuIcon/* default */.Z, {
        direction: "horizontal",
        $style: {
            marginRight: $theme.sizing.scale200,
            color: $theme.colors.black
        }
    }), props.children);
};
const RetryingPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            ...props.$style
        },
        $color: "yellow"
    }, /*#__PURE__*/ react.createElement(ErrorInfoIcon, {
        color: $theme.colors.yellow500,
        $style: {
            marginRight: $theme.sizing.scale200
        }
    }), props.children);
};
const ScheduledPill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill, {
        $style: {
            color: $theme.colors.black,
            ...props.$style
        },
        $color: "alpha"
    }, /*#__PURE__*/ react.createElement(ScheduleIcon/* ScheduleIcon */._, {
        $style: {
            color: $theme.colors.black,
            marginRight: $theme.sizing.scale200,
            width: $theme.sizing.scale550,
            height: $theme.sizing.scale550
        }
    }), props.children);
};


/***/ }),

/***/ 77301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45199);



/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("button", ({ $theme, $row, $selected, $style })=>{
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandPadding */ .ft)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandMargin */ .ds)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandBorderWidth */ .wW)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        }
    }, $style);
});


/***/ }),

/***/ 9179:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "direction")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: props.color || $theme.colors.contentSecondary,
        transform: `rotate(${rotation} 15 15)`
    }));
};


/***/ }),

/***/ 91797:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ ActionIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const ActionIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M17.0001 2.00002C16.8205 2.00022 16.6444 2.04874 16.4901 2.1405C16.3358 2.23226 16.209 2.36386 16.1231 2.5215L8.17388 15.4336V15.4356C8.06043 15.6019 7.99984 15.7987 8.00005 16C8.00005 16.2652 8.10541 16.5196 8.29294 16.7071C8.48048 16.8947 8.73483 17 9.00005 17H14.5L13.0196 26.8008C13.0064 26.8664 12.9999 26.9331 13 27C13 27.2652 13.1054 27.5196 13.2929 27.7071C13.4805 27.8947 13.7348 28 14 28C14.1818 27.9997 14.36 27.9499 14.5155 27.856C14.671 27.7621 14.798 27.6275 14.8829 27.4668H14.8848L22.8067 14.5899L22.7969 14.5723C22.9153 14.408 23 14.2178 23 14C23 13.448 22.552 13 22 13H16.5001L17.9551 3.29494C17.9848 3.19943 17.9999 3.10002 18 3.00002C18 2.7348 17.8947 2.48044 17.7072 2.29291C17.5196 2.10537 17.2653 2.00002 17.0001 2.00002V2.00002Z"
    }));


/***/ }),

/***/ 45511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ CheckmarkIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CheckmarkIcon = (props)=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 17 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M15.4528 4.28832C15.5652 4.17849 15.642 4.03738 15.6731 3.8833C15.7044 3.72859 15.6883 3.56802 15.6268 3.42265C15.5652 3.27728 15.4612 3.15388 15.3284 3.06864C15.1955 2.98339 15.04 2.94027 14.8822 2.94492C14.6794 2.95096 14.4867 3.03549 14.345 3.18066L6.36668 11.159L3.18883 7.98112C3.11704 7.90688 3.03128 7.84756 2.93647 7.80658C2.84081 7.76524 2.73785 7.74339 2.63364 7.74233C2.52943 7.74127 2.42605 7.76102 2.32957 7.80041C2.23308 7.8398 2.14543 7.89805 2.07173 7.97174C1.99804 8.04543 1.93979 8.13309 1.9004 8.22958C1.86101 8.32606 1.84127 8.42944 1.84233 8.53365C1.84339 8.63786 1.86523 8.74081 1.90658 8.83648C1.94755 8.93129 2.00687 9.01705 2.08111 9.08884L5.81282 12.8205C5.95972 12.9674 6.15897 13.0499 6.36668 13.0499C6.57439 13.0499 6.7736 12.9674 6.9205 12.8206L15.4528 4.28832Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 69525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z"
    }));


/***/ }),

/***/ 12586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 46666:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ FailureCircleIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const FailureCircleIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M8.00001 1.60001C4.46561 1.60001 1.60001 4.46561 1.60001 8.00001C1.60001 11.5344 4.46561 14.4 8.00001 14.4C11.5344 14.4 14.4 11.5344 14.4 8.00001C14.4 4.46561 11.5344 1.60001 8.00001 1.60001ZM10.5104 9.75627C10.7189 9.96481 10.7189 10.3019 10.5104 10.5104C10.4064 10.6144 10.2699 10.6667 10.1333 10.6667C9.99681 10.6667 9.86027 10.6144 9.75627 10.5104L8.00001 8.75414L6.24374 10.5104C6.13974 10.6144 6.00321 10.6667 5.86667 10.6667C5.73014 10.6667 5.59361 10.6144 5.48961 10.5104C5.28107 10.3019 5.28107 9.96481 5.48961 9.75627L7.24587 8.00001L5.48961 6.24374C5.28107 6.03521 5.28107 5.69814 5.48961 5.48961C5.69814 5.28107 6.03521 5.28107 6.24374 5.48961L8.00001 7.24587L9.75627 5.48961C9.96481 5.28107 10.3019 5.28107 10.5104 5.48961C10.7189 5.69814 10.7189 6.03521 10.5104 6.24374L8.75414 8.00001L10.5104 9.75627Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.red500)
    }));
};


/***/ }),

/***/ 87467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ ForwardArrowIcon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _SmallArrowIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39202);


const ForwardArrowIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SmallArrowIcon__WEBPACK_IMPORTED_MODULE_1__/* .SmallArrowIcon */ .X, {
        direction: "right",
        ...props
    });


/***/ }),

/***/ 1462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: () => (/* binding */ GadgetLogoMark),
  u: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 56029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const KebabMenuIcon = (props)=>{
    const rotation = props.direction === "horizontal" ? 0 : 90;
    const viewBox = props.direction === "horizontal" ? "0 0 16 16" : "0 0 8 16";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: viewBox,
        ...props,
        fill: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M2.6 6.40039C1.7164 6.40039 1 7.11679 1 8.00039C1 8.88399 1.7164 9.60039 2.6 9.60039C3.4836 9.60039 4.2 8.88399 4.2 8.00039C4.2 7.11679 3.4836 6.40039 2.6 6.40039ZM8 6.40039C7.1164 6.40039 6.4 7.11679 6.4 8.00039C6.4 8.88399 7.1164 9.60039 8 9.60039C8.8836 9.60039 9.6 8.88399 9.6 8.00039C9.6 7.11679 8.8836 6.40039 8 6.40039ZM13.4 6.40039C12.5164 6.40039 11.8 7.11679 11.8 8.00039C11.8 8.88399 12.5164 9.60039 13.4 9.60039C14.2836 9.60039 15 8.88399 15 8.00039C15 7.11679 14.2836 6.40039 13.4 6.40039Z",
        transform: `rotate(${rotation} 6 6)`
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (KebabMenuIcon);


/***/ }),

/***/ 75574:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: () => (/* binding */ ScheduleIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const ScheduleIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6.46664 0.599976V3.26664C6.46564 3.33732 6.4787 3.40748 6.50505 3.47307C6.53141 3.53865 6.57053 3.59834 6.62016 3.64867C6.66978 3.699 6.72891 3.73897 6.79412 3.76625C6.85932 3.79352 6.9293 3.80757 6.99998 3.80757C7.07066 3.80757 7.14063 3.79352 7.20584 3.76625C7.27104 3.73897 7.33017 3.699 7.37979 3.64867C7.42942 3.59834 7.46854 3.53865 7.4949 3.47307C7.52125 3.40748 7.53431 3.33732 7.53331 3.26664V1.77393C10.2202 2.05294 12.3333 4.2376 12.3333 6.99998C12.3333 9.95173 9.95173 12.3333 6.99998 12.3333C4.04822 12.3333 1.66664 9.95173 1.66664 6.99998C1.66664 5.69133 2.137 4.50011 2.91768 3.57289C2.96283 3.51927 2.99697 3.45728 3.01816 3.39046C3.03935 3.32364 3.04717 3.25331 3.04118 3.18347C3.03518 3.11363 3.01549 3.04565 2.98322 2.98342C2.95096 2.92119 2.90675 2.86593 2.85312 2.82078C2.7995 2.77564 2.7375 2.7415 2.67069 2.72032C2.60387 2.69913 2.53353 2.69132 2.46369 2.69731C2.39385 2.70331 2.32587 2.72301 2.26365 2.75528C2.20142 2.78755 2.14616 2.83176 2.10102 2.88539C1.16544 3.99658 0.599976 5.43502 0.599976 6.99998C0.599976 10.5282 3.47173 13.4 6.99998 13.4C10.5282 13.4 13.4 10.5282 13.4 6.99998C13.4 3.47173 10.5282 0.599976 6.99998 0.599976H6.46664ZM4.01039 3.80414C3.85422 3.82692 3.73764 4.01009 3.84164 4.17289C4.62244 5.39796 5.95568 7.46401 6.24581 7.75414C6.66234 8.17068 7.33761 8.17068 7.75414 7.75414C8.17068 7.33761 8.17068 6.66234 7.75414 6.24581C7.46401 5.95514 5.39796 4.62244 4.17289 3.84164C4.11863 3.80698 4.06245 3.79655 4.01039 3.80414Z"
    }));


/***/ }),

/***/ 39202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ SmallArrowIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const SmallArrowIcon = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M8.068 11.244L10.658 8.65401H3V7.33801H10.658L8.068 4.762L8.95 3.88L13.08 8.01L8.95 12.126L8.068 11.244Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor"),
        style: {
            transform: `rotate3d(0, 0, 1, ${rotation}deg)`,
            transformOrigin: "center"
        }
    }));
};


/***/ }),

/***/ 17447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ SuccessCircleIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const SuccessCircleIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00001 14.4C11.5346 14.4 14.4 11.5346 14.4 8.00001C14.4 4.46538 11.5346 1.60001 8.00001 1.60001C4.46538 1.60001 1.60001 4.46538 1.60001 8.00001C1.60001 11.5346 4.46538 14.4 8.00001 14.4ZM7.28262 10.5032L11.3104 6.28575C11.5188 6.06763 11.5188 5.71506 11.3104 5.49693C11.1021 5.27881 10.7654 5.27881 10.5571 5.49693L6.90594 9.31999L5.44293 7.78809C5.23461 7.56996 4.89789 7.56996 4.68958 7.78809C4.48126 8.00621 4.48126 8.35878 4.68958 8.57691L6.52927 10.5032C6.6289 10.6081 6.76476 10.6667 6.90594 10.6667C7.04713 10.6667 7.18246 10.6081 7.28262 10.5032Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.green600)
    }));
};


/***/ }),

/***/ 2009:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QG: () => (/* binding */ useOverrides)
/* harmony export */ });
/* unused harmony exports getOverrides, BasewebSelectVerbose */
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61230);
/* harmony import */ var lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_mapValues__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31682);
/* harmony import */ var lodash_values__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_values__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30242);



function maybeMerge(a, b) {
    return a && b ? {
        ...a,
        ...b
    } : a || b;
}
const getOverrides = (override, Component, props)=>{
    // component override shortcut:
    if (typeof override === "function") {
        Component = override;
    } else if (override) {
        const { style, props: propsOverride, component } = override;
        // assume at least one of the folllowing will override props, so clone
        props = {
            ...props
        };
        // component override:
        if (component) {
            Component = component;
        }
        // props override:
        if (propsOverride) {
            Object.assign(props, propsOverride);
        }
        // style override:
        if (style) {
            props.style = maybeMerge(props.style, typeof style === "function" ? style(props) : style);
        // TODO: support $style?
        // props.$style = style;
        }
    // nested overrides:
    // if (Object.keys(nested).length > 0) {
    //   props.overrides = maybeMerge(props.overrides, nested);
    // }
    }
    return [
        Component,
        props
    ];
};
const createOverridenComponent = (name, Component, getOverrideForRender)=>{
    const wrapped = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef((props, ref)=>{
        const override = getOverrideForRender();
        if (override) {
            const [NewComponent, mergedProps] = getOverrides(override, Component, props);
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(NewComponent, {
                ...mergedProps,
                ref: ref
            });
        } else {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, {
                ...props,
                ref: ref
            });
        }
    });
    wrapped.displayName = `${name}WithOverrides`;
    return wrapped;
};
const useOverrides = (defaultComponents, overrides = {})=>{
    const overridesRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(overrides);
    overridesRef.current = overrides;
    const x = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        return lodash_mapValues__WEBPACK_IMPORTED_MODULE_0___default()(defaultComponents, (value, name)=>createOverridenComponent(name, defaultComponents[name], ()=>overridesRef.current[name]));
    }, lodash_values__WEBPACK_IMPORTED_MODULE_1___default()(defaultComponents)); // eslint-disable-line react-hooks/exhaustive-deps
    return x;
};
/**
 * For a better DevTools inspection experience
 */ const BasewebSelectVerbose = Object.assign({}, ...[
    "Root",
    "ControlContainer",
    "Placeholder",
    "ValueContainer",
    "SingleValue",
    "MultiValue",
    "Tag",
    "InputContainer",
    "Input",
    "IconsContainer",
    "SelectArrow",
    "ClearIcon",
    "LoadingIndicator",
    "SearchIconContainer",
    "SearchIcon",
    "Popover",
    "DropdownContainer",
    "Dropdown",
    "DropdownOption",
    "DropdownListItem",
    "OptionContent",
    "StatefulMenu"
].map((override)=>({
        [override]: {
            props: {
                "data-baseweb-id": override
            }
        }
    })));


/***/ }),

/***/ 98221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   tv: () => (/* binding */ useRouter),
/* harmony export */   uW: () => (/* binding */ routingStore)
/* harmony export */ });
/* unused harmony export RouterContext */
/* harmony import */ var _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73262);
/* harmony import */ var _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var history__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86380);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);



const browserHistory = (0,history__WEBPACK_IMPORTED_MODULE_2__.createBrowserHistory)();
const routingStore = new _superwf_mobx_react_router__WEBPACK_IMPORTED_MODULE_0__.RouterStore(browserHistory);
const RouterContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(routingStore);
const useRouter = ()=>react__WEBPACK_IMPORTED_MODULE_1__.useContext(RouterContext);


/***/ }),

/***/ 10075:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  id: () => (/* binding */ DeployAwareEnvironmentNameTag),
  mK: () => (/* binding */ EnvironmentNameLabel),
  Kk: () => (/* binding */ EnvironmentNamePill),
  hu: () => (/* binding */ EnvironmentNameTag),
  Fx: () => (/* binding */ EnvironmentNameTags)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(71567);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Pill.tsx + 1 modules
var Pill = __webpack_require__(87650);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/DownLeftArrowIcon.tsx


const DownLeftArrowIcon = (props)=>{
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M1.50791 2.65924C1.6404 2.66131 1.76666 2.71589 1.85895 2.81098C1.95123 2.90607 2.002 3.0339 2.0001 3.1664V8.1664C2.0001 8.63248 2.36736 8.99974 2.83343 8.99974H13.2931L10.8132 6.51992C10.7411 6.44967 10.6919 6.35927 10.672 6.26057C10.652 6.16187 10.6624 6.05946 10.7017 5.96673C10.7409 5.87401 10.8072 5.7953 10.892 5.7409C10.9767 5.6865 11.0759 5.65895 11.1765 5.66184C11.3064 5.66563 11.4297 5.7198 11.5203 5.81289L14.8536 9.14622C14.9473 9.23999 15 9.36715 15 9.49973C15 9.63232 14.9473 9.75948 14.8536 9.85325L11.5203 13.1866C11.4742 13.2346 11.419 13.2729 11.358 13.2993C11.2969 13.3257 11.2312 13.3396 11.1647 13.3403C11.0981 13.341 11.0322 13.3284 10.9706 13.3032C10.909 13.2781 10.853 13.2409 10.806 13.1938C10.7589 13.1468 10.7218 13.0909 10.6966 13.0293C10.6715 12.9677 10.6589 12.9017 10.6596 12.8352C10.6602 12.7687 10.6742 12.7029 10.7006 12.6419C10.727 12.5808 10.7653 12.5256 10.8132 12.4796L13.2931 9.99973H2.83343C1.82684 9.99973 1.0001 9.17299 1.0001 8.1664V3.1664C0.999138 3.09948 1.01162 3.03305 1.03681 2.97104C1.062 2.90903 1.09938 2.85271 1.14673 2.80541C1.19409 2.75812 1.25046 2.72081 1.3125 2.6957C1.37454 2.67059 1.44099 2.65819 1.50791 2.65924Z"
    }));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ForwardArrowIcon.tsx
var ForwardArrowIcon = __webpack_require__(87467);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/omit.js
var omit = __webpack_require__(73352);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(22764);
// EXTERNAL MODULE: ../state-trees/src/Environment.ts
var Environment = __webpack_require__(96431);
// EXTERNAL MODULE: ./src/components/edit/workspace/EnvironmentContext.tsx
var EnvironmentContext = __webpack_require__(50623);
;// CONCATENATED MODULE: ./src/components/edit/editor/environment/EnvironmentNameTag.tsx









const DeployAwareEnvironmentNameTag = (0,es/* observer */.Pi)((props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.hQ)();
    const prodRoot = (0,EnvironmentContext/* useProductionEnvironment */._F)();
    const prodSettings = prodRoot.settings.getOrSuspend();
    const isPublished = prodSettings.isEnvironmentActive;
    const isProduction = props.environment == Environment/* ProductionEnvironmentName */.KG;
    const pendingDeploy = isProduction && (!isPublished || props.pendingDeploy);
    return pendingDeploy ? /*#__PURE__*/ react.createElement(EnvironmentNameTag, omit_default()(props, "pendingDeploy"), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale200
    }, /*#__PURE__*/ react.createElement(ForwardArrowIcon/* ForwardArrowIcon */.R, null), "pending deploy")) : /*#__PURE__*/ react.createElement(EnvironmentNameTag, props);
});
/**
 * Span which auto colors the text based on the environment name
 * No background
 **/ const EnvironmentNameTag = (props)=>{
    // eslint-disable-next-line react/no-unknown-property
    const isProduction = props.environment.toLowerCase() == "production";
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Pill/* Pill */.DR, {
        $color: isProduction ? "production" : "teal",
        title: props.environment.toLowerCase(),
        $style: {
            maxWidth: "100%",
            paddingLeft: isProduction ? $theme.sizing.scale100 : "3px"
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            color: isProduction ? $theme.colors.contentProduction : $theme.colors.contentDevelopment,
            fontWeight: 500,
            height: "20px",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            ...props.$style
        }),
        "data-widget": "environment-name-tag",
        ...omit_default()(props, [
            "$style",
            "environment"
        ]),
        title: props.environment.toLowerCase()
    }, props.children ?? /*#__PURE__*/ react.createElement(EnvironmentNameLabel, {
        showArrowIcon: !isProduction && window.GadgetEditConfig.multiEnvironmentEnabled,
        envName: props.environment
    })));
};
const EnvironmentNameLabel = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(react.Fragment, null, props.showArrowIcon && /*#__PURE__*/ react.createElement(DownLeftArrowIcon, {
        $style: {
            marginRight: $theme.sizing.scale200,
            maxHeight: $theme.sizing.scale600,
            verticalAlign: "text-bottom"
        }
    }), /*#__PURE__*/ react.createElement("span", {
        style: {
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.envName.toLowerCase()));
};
/**
 * Span which auto colors the text based on the environment name
 * Pill shaped with a background
 **/ const EnvironmentNamePill = (props)=>{
    const [_css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(EnvironmentNameTag, {
        ...props,
        $style: {
            borderRadius: $theme.borders.radius200,
            padding: "0px 4px",
            ...props.$style
        }
    });
};
const EnvironmentNameTags = {
    Development: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* DevelopmentEnvironmentName */.y2
        }, "Development"),
    development: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* DevelopmentEnvironmentName */.y2
        }, "development"),
    Production: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* ProductionEnvironmentName */.KG
        }, "Production"),
    production: (props)=>/*#__PURE__*/ react.createElement(EnvironmentNameTag, {
            ...props,
            environment: Environment/* ProductionEnvironmentName */.KG
        }, "production")
};
EnvironmentNameTags.Development.textContent = "Development";
EnvironmentNameTags.development.textContent = "development";
EnvironmentNameTags.Production.textContent = "Production";
EnvironmentNameTags.production.textContent = "production";


/***/ }),

/***/ 50623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GP: () => (/* binding */ useCurrentEnvironment),
/* harmony export */   Gf: () => (/* binding */ useCurrentApplication),
/* harmony export */   Gq: () => (/* binding */ ApplicationRootContext),
/* harmony export */   H2: () => (/* binding */ ProductionEnvironmentRootContext),
/* harmony export */   Z3: () => (/* binding */ CurrentEnvironmentRootContext),
/* harmony export */   _F: () => (/* binding */ useProductionEnvironment),
/* harmony export */   j1: () => (/* binding */ useCurrentEnvironmentSettings)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

const ApplicationRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useCurrentApplication = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ApplicationRootContext);
const CurrentEnvironmentRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useCurrentEnvironment = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CurrentEnvironmentRootContext);
const useCurrentEnvironmentSettings = ()=>useCurrentEnvironment().settings.getOrSuspend();
const ProductionEnvironmentRootContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
const useProductionEnvironment = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductionEnvironmentRootContext);


/***/ }),

/***/ 63467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Qw: () => (/* binding */ getSearchParams),
  Cu: () => (/* binding */ maybeOpenUpgradeModal),
  wV: () => (/* binding */ replaceYuckyQueryParams),
  LQ: () => (/* binding */ useDocsRoute)
});

// UNUSED EXPORTS: roundOutClipPath

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/range.js
var lodash_range = __webpack_require__(38569);
// EXTERNAL MODULE: ../../node_modules/.pnpm/qs@6.11.0/node_modules/qs/lib/index.js
var lib = __webpack_require__(46163);
// EXTERNAL MODULE: ./src/components/edit/workspace/EnvironmentContext.tsx
var EnvironmentContext = __webpack_require__(50623);
;// CONCATENATED MODULE: ../docs/src/chrome/FullMetaBlob.tsx
const DocsVersions = [
    {
        id: "actions-as-code",
        prefix: "/v0",
        rootURL: "/v0/",
        dir: "docs/pages/guides/2-actions-as-code",
        frameworkRange: "<=0.3.1",
        label: "v0"
    },
    {
        id: "multi-env",
        prefix: "",
        rootURL: "/",
        dir: "docs/pages/guides/3-multi-env",
        frameworkRange: ">=1.0.0",
        label: "v1"
    }
];
const MultiEnvironmentDocsVersion = DocsVersions[1];
const ActionsAsCodeDocsVersion = DocsVersions[0];
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const DefaultDocsVersion = DocsVersions.find((version)=>version.prefix == "");

;// CONCATENATED MODULE: ./src/components/edit/workspace/utils.tsx




// rounded out corner setup: https://css-tricks.com/tabs-with-round-out-borders/
const roundOutClipPath = (points = 10, left = true, bottom = false)=>{
    let coords = range(points + 1).map((x)=>[
            x,
            Math.sqrt(points ** 2 - (left ? x : points - x) ** 2)
        ]); // get circle coords
    if (bottom) {
        coords = coords.map(([x, y])=>[
                x,
                points - y
            ]);
    }
    return `polygon(
    ${coords.map(([x, y])=>`${Math.round(x * 100 / points)}% ${Math.round(y * 100 / points)}%`).join(", ")},
    ${left ? bottom ? "100% 0%" : "100% 100%" : "0% 100%"}
  )`;
};
const maybeOpenUpgradeModal = (root, router)=>{
    const params = getSearchParams(router);
    if (params["upgradePlan"]) {
        root.currentEnvironment.upgradePlanModal.open();
        delete params["upgradePlan"];
    }
    replaceParams(router, params);
};
const YuckyParams = [
    "sessionboot",
    "gclid"
];
// Removes internal implementation params from the URL that devs have to stare at all day
const replaceYuckyQueryParams = (router)=>{
    const params = getSearchParams(router);
    for (const param of YuckyParams){
        delete params[param];
    }
    replaceParams(router, params);
};
const replaceParams = (router, newParams)=>{
    let newPath = router.location.pathname;
    if (Object.keys(newParams).length > 0) {
        newPath += "?" + (0,lib.stringify)(newParams);
    }
    // add the hash (used for Readme files)
    if (router.location.hash) {
        newPath += router.location.hash;
    }
    router.history.replace(newPath);
};
//router.location.search unexpectedly includes the '?' as the first character of the query
const getSearchParams = (router)=>{
    let search = router.location.search;
    if (search.startsWith("?")) search = search.slice(1);
    return (0,lib.parse)(search);
};
const useDocsRoute = ()=>{
    const currentEnvSettings = (0,EnvironmentContext/* useCurrentEnvironmentSettings */.j1)();
    const docsPrefix = DocsVersions.find((docVersion)=>currentEnvSettings.frameworkVersion.satisfies(docVersion.frameworkRange))?.prefix;
    const generateDocsLink = (pathOrHref, options = {})=>{
        const url = new URL(pathOrHref, window.GadgetEditConfig.docsRootURL);
        if (!pathOrHref.includes("/guides")) {
            return url.toString();
        }
        url.searchParams.set("slug", currentEnvSettings.applicationSlug);
        if (docsPrefix && options.applyVersioning) {
            return url.toString().replace(window.GadgetEditConfig.docsRootURL, `${window.GadgetEditConfig.docsRootURL}${docsPrefix}`);
        } else {
            return url.toString();
        }
    };
    return {
        baseUrl: window.GadgetEditConfig.docsRootURL,
        generateDocsLink
    };
};


/***/ })

}]);